import React from 'react';
import { Show, useTable, EditButton, ShowButton, DeleteButton } from '@refinedev/antd';
import { useShow } from '@refinedev/core';
import { Table, Space, Tag, Button, Divider, theme } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { AdminSurveyDetailDto, AdminSurveyScreenListItemDto } from '@wellverse/shared-ts';
import { Field } from '../../components/Field';

export const SurveyShow: React.FC = () => {
  const { token } = theme.useToken();
  const navigate = useNavigate();
  const { queryResult } = useShow<AdminSurveyDetailDto>({ resource: 'surveys' });
  const item = queryResult?.data?.data;

  const { tableProps } = useTable<AdminSurveyScreenListItemDto>({
    resource: 'survey-screens',
    filters: {
      permanent: item?.id
        ? [
            {
              field: 'surveyId',
              operator: 'eq',
              value: item.id,
            },
          ]
        : [],
    },
    queryOptions: {
      enabled: !!item?.id,
    },
  });

  if (!item) {
    return <div style={{ color: token.colorTextSecondary }}>Loading...</div>;
  }

  return (
    <Show resource="surveys">
      <div style={{ padding: '8px 0' }}>
        <Field label="Name">{item.name}</Field>
        <Field label="Type">{item.type}</Field>
        <Field label="Version">{item.version}</Field>
        <Field label="Active">
          <Tag
            style={{
              borderColor: item.isActive ? '#3ecf8e' : '#898989',
              color: item.isActive ? '#3ecf8e' : '#898989',
              background: item.isActive ? '#3ecf8e15' : '#89898915',
              borderRadius: 9999,
              padding: '2px 12px',
              fontWeight: 500,
            }}
          >
            {item.isActive ? 'Active' : 'Inactive'}
          </Tag>
        </Field>
        <Field label="Created At">{new Date(item.createdAt).toLocaleString()}</Field>
      </div>

      <Divider style={{ borderColor: token.colorBorder }} />

      <div
        style={{
          marginBottom: 16,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <h3 style={{ color: token.colorText, margin: 0 }}>Screens</h3>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => navigate(`/survey-screens/create?surveyId=${item.id}`)}
        >
          Add Screen
        </Button>
      </div>

      <Table {...tableProps} rowKey="id">
        <Table.Column dataIndex="screenKey" title="Screen Key" />
        <Table.Column dataIndex="type" title="Type" />
        <Table.Column dataIndex="orderIndex" title="Order" />
        <Table.Column dataIndex="questionCount" title="Questions" />
        <Table.Column
          title="Actions"
          dataIndex="actions"
          render={(_, record: AdminSurveyScreenListItemDto) => (
            <Space>
              <ShowButton hideText size="small" recordItemId={record.id} resource="survey-screens" />
              <EditButton hideText size="small" recordItemId={record.id} resource="survey-screens" />
              <DeleteButton hideText size="small" recordItemId={record.id} resource="survey-screens" />
            </Space>
          )}
        />
      </Table>
    </Show>
  );
};
